import { useAuth0 } from '@auth0/auth0-react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';

export function Header() {
  const { logout } = useAuth0();
  const { isFullyAuthenticated, user } = useAuth();
  
  const handleLogout = () => {
    // Clear session storage
    sessionStorage.removeItem('mfa_verified');
    // Log out from Auth0
    logout({ 
      logoutParams: {
        returnTo: window.location.origin 
      }
    });
  };
  
  return (
    <header className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-gray-900">
              FaceTec Auth Test
            </Link>
          </div>
          
          <div className="flex items-center">
            {isFullyAuthenticated ? (
              <div className="flex items-center space-x-4">
                <span className="text-gray-700">
                  {user?.first_name} {user?.last_name}
                </span>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}